import axios from 'axios';

type EmailOptions = {
  from?: string;
  to?: { email: string }[];
  subject?: string;
  html?: string;
  replyTo?: { email: string; alias: string }[];
  bcc?: { email: string }[];
  sendOnDate?: Date;
};

export class EmailService {
  static send(options?: EmailOptions) {
    axios.post('https://mailservice.cliqueiachei.com.br/email', {
      from: options?.from ?? 'naoresponda@cliqueiachei.com.br',
      to: options?.to ?? [],
      assunto: options?.subject ?? '',
      html: options?.html ?? '',
      ...(options?.replyTo && { replayTo: options?.replyTo }),
      ...(options?.bcc && { bcc: options.bcc }),
      ...(options?.sendOnDate && { delayed: { sendOnDate: this.formatSendOn(options.sendOnDate) } }),
    });
  }

  private static formatSendOn(date: Date) {
    return JSON.parse(JSON.stringify({ date })).date;
  }

  static defaultEmails() {
    const result = [{ email: 'jefersoncliqueiachei@gmail.com' }];
    if (process.env.NODE_ENV === 'production') result.push({ email: 'harlane@inteligenciacriativa.com.br' });
    return result;
  }
}
